import { render, staticRenderFns } from "./breedingPig.vue?vue&type=template&id=6b2f6246&"
import script from "./breedingPig.vue?vue&type=script&lang=js&"
export * from "./breedingPig.vue?vue&type=script&lang=js&"
import style0 from "./breedingPig.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports